import * as React from 'react';
var self;
export interface StatusFilter {
    statusData: any[]
    AllGenset_Count: number
    ReportingSWOn_Count: number
    LastReportedSWOn_Count: number
    ReportingSWOff_Count: number
    LastReportedSWOff_Count: number   
    gensetStatusFilters: GensetStatusFilters
}
interface GensetStatusFilters {
    AllGenset: boolean,
    ReportingSWOn: boolean,
    LastReportedSWOn: boolean,
    ReportingSWOff: boolean,
    LastReportedSWOff: boolean   
}
const emptySearchFilters = {
    AllGenset: false, ReportingSWOn: false, LastReportedSWOn: false, ReportingSWOff: false, LastReportedSWOff: false
};
var isPanelLoaded;
export class GensetToggleButtonsFilter extends React.Component<any, StatusFilter> {
    constructor(props: any) {
        super(props);
        this.state = {
            statusData: [],
            AllGenset_Count: 0,
            ReportingSWOn_Count: 0,
            LastReportedSWOn_Count: 0,
            ReportingSWOff_Count: 0,
            LastReportedSWOff_Count: 0,           
            gensetStatusFilters: emptySearchFilters
        }

        self = this;
        isPanelLoaded = false;
    }

    componentWillReceiveProps(nextprops: any) {     
        if (nextprops.gridData != undefined && nextprops.gridData != null && isPanelLoaded == true) {
            this.setStatusFilters(nextprops);
        }
        if (!isPanelLoaded) {
            isPanelLoaded = true;
        }
    }

    setStatusFilters(nextprops: any) {
        self.setState({
            isPanelLoaded: true,
            statusData: nextprops.gridData,
            AllGenset_Count: nextprops.gridData.length,
            ReportingSWOn_Count: nextprops.gridData.filter(x => x.IgnitionOn == true && x.IsReportingDelay == false).length,
            LastReportedSWOn_Count: nextprops.gridData.filter(x => x.IgnitionOn == true && x.IsReportingDelay == true).length,
            ReportingSWOff_Count: nextprops.gridData.filter(x => (x.IgnitionOn == false || x.IgnitionOn==null) && x.IsReportingDelay == false).length,
            LastReportedSWOff_Count: nextprops.gridData.filter(x => (x.IgnitionOn == false || x.IgnitionOn==null) && x.IsReportingDelay == true).length           
        });
    }
    
    ApplyStatusFilter(param: string, event: React.FormEvent<HTMLInputElement>) {
        var searchFilter = this.state.gensetStatusFilters;
        var isChecked: boolean = event.currentTarget.checked;
        switch (param) {
            case "AllGenset":
                searchFilter.AllGenset = isChecked;
                break;
            case "ReportingSWOn":
                searchFilter.ReportingSWOn = isChecked;
                break
            case "LastReportedSWOn":
                searchFilter.LastReportedSWOn = isChecked;
                break;
            case "ReportingSWOff":
                searchFilter.ReportingSWOff = isChecked;
                break;
            case "LastReportedSWOff":
                searchFilter.LastReportedSWOff = isChecked;
                break;           
        }
        
        this.setState({
            gensetStatusFilters: searchFilter
        });
        
        self.props.filterGensetStatusGrid(searchFilter);
    }

    static ClearToggleFilters() {
        if (self != undefined) {
            var searchFilter = self.state.gensetStatusFilters;
            searchFilter.AllGenset = false;
            searchFilter.ReportingSWOn = false;
            searchFilter.LastReportedSWOn = false;
            searchFilter.ReportingSWOff = false;
            searchFilter.LastReportedSWOff = false;          
            self.setState({
                gensetStatusFilters: searchFilter
            });
        }
    }

    ClearGensetStatusFilters() {
        var searchFilter = self.state.gensetStatusFilters;
        searchFilter.AllGenset = false;
        searchFilter.ReportingSWOn = false;
        searchFilter.LastReportedSWOn = false;
        searchFilter.ReportingSWOff = false;
        searchFilter.LastReportedSWOff = false;       
        self.setState({
            gensetStatusFilters: searchFilter
        });

        self.props.filterGensetStatusGrid(searchFilter);
    }

    public render() {
        return <div>
            <form>
               
                    <div className="btn-group btn-group-sm btn-group-dsd" role="group">
                        <button type="button" className="btn btn-outline-secondary" onClick={self.ClearGensetStatusFilters.bind(this)}>
                            <span className="fa-solid fa-trash-can me-1 fa-sm"></span>
                            Clear filters                      
                        </button>

                        <button type="button" className="btn btn-outline-secondary dropdown-toggle" data-bs-auto-close="outside" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span className="fa-solid fa-filter me-1 fa-sm"></span>
                           Apply filters
                        <span className="caret"></span>
                        </button>
                        <div className='dropdown-menu dropdown-menu-end'>
                            <div className='d-flex gap-2 px-2'>
                            <ul className='list-group'>
                                <li className="list-group-item d-flex align-items-center fw-medium">Grid Filters</li>
                                {/*<li className="list-group-item d-flex align-items-center">  <input className="form-check-input me-2" type="checkbox" checked={this.state.gensetStatusFilters.AllGenset} onChange={this.ApplyStatusFilter.bind(this, 'AllGenset')} /> <span className='form-check-label me-3'> Total Gensets </span> <span className="badge rounded-pill green ms-auto"> {this.state.AllGenset_Count} </span>  </li>*/}
                                <li className="list-group-item d-flex align-items-center"> <input className="form-check-input me-2" type="checkbox" checked={this.state.gensetStatusFilters.ReportingSWOn} onChange={this.ApplyStatusFilter.bind(this, 'ReportingSWOn')} /> <span className='form-check-label me-3'> Reporting, Switched On </span>  <span className="badge rounded-pill green ms-auto green">  {this.state.ReportingSWOn_Count}  </span> </li>
                                <li className="list-group-item d-flex align-items-center"> <input className="form-check-input me-2" type="checkbox" checked={this.state.gensetStatusFilters.LastReportedSWOn} onChange={this.ApplyStatusFilter.bind(this, 'LastReportedSWOn')} /> <span className='form-check-label me-3'> Last Reported Switched On </span> <span className="badge rounded-pill green ms-auto orange"> {this.state.LastReportedSWOn_Count}  </span> </li>
                                <li className="list-group-item d-flex align-items-center"><input className="form-check-input me-2" type="checkbox" checked={this.state.gensetStatusFilters.ReportingSWOff} onChange={this.ApplyStatusFilter.bind(this, 'ReportingSWOff')} /> <span className='form-check-label me-3'> Reporting, Switched Off </span> <span className="badge rounded-pill green ms-auto blue"> {this.state.ReportingSWOff_Count}  </span> </li>
                                <li className="list-group-item d-flex align-items-center"> <input className="form-check-input me-2" type="checkbox" checked={this.state.gensetStatusFilters.LastReportedSWOff} onChange={this.ApplyStatusFilter.bind(this, 'LastReportedSWOff')} /> <span className='form-check-label me-3'> Last Reported Switched Off  </span> <span className="badge rounded-pill green ms-auto greybg">  {this.state.LastReportedSWOff_Count}  </span> </li>
                            </ul>
                            </div>
                       </div>
                    </div>                   
                             
            </form>
        </div>;
    }
}

